import { request } from "@src/utils";

const signout = async () => {
  return request.get("/api/user/signout", {});
};

export default signout;
